import { Component } from 'react'
import { connect } from 'react-redux'
import Link from '../Link'
import { formatFileLink } from '../../cdl-react-components/utilities/files'
import { setConfiguration } from '../../../store/actions'
import { graphqlFetch } from '../../cdl-react-components/utilities'

class RecentActivityMap extends Component {
    render() {
        const { recentActivityMap } = this.props 
        return recentActivityMap ? (
            <Link 
                className="recent-activity-map"
                title={recentActivityMap.title}
                href={'/activityMap/' + recentActivityMap.id}>
                <img className="recent-activity-map__img" alt={recentActivityMap.title} src={formatFileLink(recentActivityMap.add_image)} />
            </Link>
        ) : null
    }

    componentDidMount() {
        if (!this.props.recentActivityMap) {
            graphqlFetch('wcms3', `
                query {
                    activityMaps (
                        order: { publicationDate: DESC }
                        take: 1
                    ) {
                        items {
                            id
                            title
                            subtitle
                            publication_date: publicationDate
                            add_image: addImage
                        }
                    }
                }`)
                .then(res => {
                    const recentActivityMap = res.data.activityMaps.items[0] || undefined
                    this.props.setRecentActivityMap(recentActivityMap)
                })
        }
    }
}

const mapStateToProps = ({ data }) => ({ recentActivityMap: data.configuration.recentActivityMap })
const mapDispatchToProps = (dispatch) => ({ setRecentActivityMap: recentActivityMap => dispatch(setConfiguration({ recentActivityMap }))})

export default connect(mapStateToProps, mapDispatchToProps)(RecentActivityMap)